// Site adatok — egyetlen forrás a teljes oldal szövegéhez.

export const COMPANY = {
  name: "Totál-Bádogos Kft.",
  short: "Totál-Bádogos Kft.",
  initials: "TB",
  established: 1994,
  phone: "+36 20 923 4767",
  phoneHref: "tel:+36209234767",
  phoneDisplay: "+36 20 / 923 4767",
  email: "totalbadogos@gmail.com",
  serviceArea: "Helyszín és időpont egyeztetés szerint",
  address: {
    city: "Magyarország",
  },
  hours: "Hétfő–Szombat · 07:00 – 18:00",
  rating: 4.9,
  reviewCount: 142,
  roofsCompleted: 1247,
  guaranteeYears: 5,
  insuranceAmount: "100 millió Ft",
  leadCraftsman: "Totál-Bádogos Kft.",
  leadTitle: "Bádogos és tetőfedő szakemberek",
};

export const NAV_LINKS = [
  { label: "Munkák", href: "/munkak" },
  { label: "Referenciák", href: "/referenciak" },
  { label: "Rólunk", href: "/rolam" },
  { label: "Kapcsolat", href: "/kapcsolat" },
];

export const TRUST_ITEMS = [
  "Saját ácsbrigád",
  "Írásos garancia",
  "Ingyenes helyszíni felmérés",
  "Tételes árajánlat",
  "Minőségi alapanyagok",
  "Megbízható kivitelezés",
];

export const SERVICES = [
  {
    slug: "cserepteto",
    number: "01",
    title: "Cseréptető",
    shortTitle: "Cseréptető",
    summary:
      "Tondach, Bramac, Creaton. Kézzel rakva, kézzel zárva. Az a tető, amire harminc évig nem kell gondolnia.",
    long:
      "Égetett agyagcserép, betoncserép, hódfarkú és vágott — minden rögzítés mechanikus, minden szegély szakszerűen lekötve, minden gerincelem szárazon kötve a hatályos szabványok szerint.",
    scope: [
      "Teljes vagy részleges fedéscsere",
      "Egyedi cserép- vagy palaelemek pótlása",
      "Szárazon szerelt szegély és gerinc",
      "Hófogó, rejtett ereszcsatorna és vápalemez felújítás",
      "Alátétfólia és lécezés teljes cseréje",
    ],
    faqs: [
      { q: "Mennyi idő egy teljes fedéscsere?", a: "Egy átlagos sátortetős családi ház 5–8 munkanap, időjárástól függően. Reggelente röviden megbeszéljük a napot, este takarítunk." },
      { q: "Pótolják az eredeti cserepet?", a: "Ahol még gyártják, igen — pontosan. Ahol nem, bontott készletből pótoljuk, és mintát hozunk jóváhagyásra a munka megkezdése előtt." },
      { q: "Az állványozás benne van az árban?", a: "Igen. Magastetős munkán kivétel nélkül. Az állványozás teljes egészében szerepel az árajánlatban." },
      { q: "Milyen garanciát kapok?", a: "5 éves írásos kivitelezői garancia, plusz a cseréptípus gyári garanciája (jellemzően 30–50 év)." },
      { q: "Kell-e építési engedély?", a: "Azonos típusra cserélve általában nem. Tetősík vagy fedéstípus változtatásnál szükség lehet — még az ajánlat előtt egyértelműen elmondom." },
    ],
  },
  {
    slug: "lemezfedes",
    number: "02",
    title: "Lemezfedés",
    shortTitle: "Lemez",
    summary:
      "Korcolt cink, alumínium és színes acél lemez. Modern bővítések, kis hajlású tetők, ipari elegancia.",
    long:
      "Korcolt cink, előoxidált alumínium és Lindab Premium színes acél — a gyártói előírások szerint, írásban dokumentált rétegrendben kivitelezve.",
    scope: [
      "Állókorcolt cinklemez fedés",
      "Előoxidált alumíniumlemez",
      "Trapéz- és cserepeslemez",
      "Alacsony hajlás és íves geometria",
      "Rejtett és átmenő rögzítésű rendszerek",
    ],
    faqs: [
      { q: "Hangosabb-e a lemez a cserépnél?", a: "Megfelelő alátétfóliával és akusztikai szigeteléssel nem érzékelhető a lakótérben." },
      { q: "Meddig tart egy cinktető?", a: "Pontosan kivitelezett cinkfedés 80–100 éves élettartamú." },
      { q: "Mekkora lehet a minimum hajlásszög?", a: "Állókorcolt lemez akár 3°-tól megy. A pontos minimumot az adott rendszerre írásban megadom." },
      { q: "Modern bővítéshez passzol?", a: "Igen — és előoxidált mintát is hozok a helyszínre, hogy a pontos színt és patinát Ön válassza." },
      { q: "Tetőablakot is beépítenek?", a: "Igen. Velux, Roto és egyedi szegélyezések egy csomagban a fedéssel." },
    ],
  },
  {
    slug: "tetoszerkezet",
    number: "03",
    title: "Tetőszerkezet",
    shortTitle: "Szerkezet",
    summary:
      "Szarufa, szelemen, székállás. Statikai felülvizsgálat, bővítés, rekonstrukció — ácsmunka első kézből.",
    long:
      "Minden jó tető mögött van egy szerkezet, amit senki nem lát. Statikai felmérés, szarufapótlás, szelemencsere, teljes újraácsolás — szükség esetén tervező statikus bevonásával.",
    scope: [
      "Tetőszerkezeti statikai felmérés és szakvélemény",
      "Szarufa és szelemen csere",
      "Hagyományos és modern fedélszék készítés",
      "Beton- és acélgerenda elhelyezés",
      "Statikus által aláírt tervek és számítások",
    ],
    faqs: [
      { q: "Kell-e tervező statikus?", a: "Bármilyen teherhordó változtatáshoz igen. Saját statikussal dolgozom, a díj az árajánlat része." },
      { q: "Építésszel együtt dolgoznak?", a: "Igen, sőt szívesebben. Részt veszek tervezési egyeztetéseken és bejárásokon." },
      { q: "Hogyan vizsgálják a faanyag állapotát?", a: "Szemrevételezés, nedvességmérés, és ahol kell, kismértékű roncsolásos minta. A leletet kötelezettség nélkül megosztom." },
      { q: "Engedélyköteles munkát is vállalnak?", a: "Igen — a tervezést és a statikai számításokat hozzuk, a műszaki ellenőrt Ön bízza meg. Minden helyszíni egyeztetésen ott vagyok." },
      { q: "Vihar utáni helyreállítást is csinálnak?", a: "Igen. A biztosítóval szükséges dokumentációt térítésmentesen elkészítjük." },
    ],
  },
  {
    slug: "tetofelujitas",
    number: "04",
    title: "Tetőfelújítás",
    shortTitle: "Felújítás",
    summary:
      "Műemlék, polgári ház, makacs régi pala. Felújítás úgy, hogy a ház karaktere megmarad.",
    long:
      "Vannak tetők, amiket nem megoldani kell — tisztelni kell. A felújítás türelmes, kutatómunka-igényű feladat: eredeti anyagok, eredeti részletképzések, és semmi modern, ami nem rejthető.",
    scope: [
      "Műemléki és örökségvédelmi egyeztetés",
      "Bontott pala és cserép beszerzés",
      "Hagyományos bádogos és ólmozási munkák",
      "Kézi élszedés, csapozott székállás",
      "Mésztartalmú vakolat és habarcs alkalmazása",
    ],
    faqs: [
      { q: "Védett épületen is dolgoznak?", a: "Rendszeresen. Műemléki és helyi védett ingatlanokon végzett munkáink örökségvédelmi szakhatóság által aláírva." },
      { q: "Honnan szerzik a bontott palát?", a: "Bevizsgált bontási telepekről, minden tételt szemrevételezünk a vásárlás előtt." },
      { q: "Ólmozást is hagyományos módon csinálják?", a: "Igen — kézzel hajlított és hegesztett ólomlemez örökségvédelmi munkán. Műanyag helyettesítőt ide nem teszünk." },
      { q: "Meddig tart egy felújítás?", a: "Tovább, mint az újrafedés. Egy átlagos parasztház 2–4 hét, a felmérésnél pontosan elmondom." },
      { q: "Készülnek-e munkafolyamati tervek?", a: "Műemléki munkán minden esetben — és még a bontás előtt egyeztetem az örökségvédelmi felügyelővel." },
    ],
  },
  {
    slug: "badogos-szigeteles",
    number: "05",
    title: "Bádogos & Szigetelés",
    shortTitle: "Bádogos",
    summary:
      "Meleg tető, hideg tető, ólmozás. A láthatatlan munka, amitől a tető harminc évig bírja.",
    long:
      "Egy jól bekötött bádogos szegély, egy szabályosan szellőzött szigetelés, egy téglahézagba mart kéménybekötés — ezek a részletek döntik el, hogy a tető harminc évig tart vagy ötben elromlik.",
    scope: [
      "Meleg és hideg tetők szigetelése",
      "Kémény, fal és attika bádogos bekötés",
      "Lépcsős és átfedéses szegélylemez",
      "Ereszcsatorna és gerincszellőzés korszerűsítés",
      "Páralecsapódás vizsgálat és javítás",
    ],
    faqs: [
      { q: "Csökkenti-e a szigetelés a fűtésszámlát?", a: "A 2000 előtti épületek tetőin igen — és a reális számot mondom, nem a marketinget." },
      { q: "Használnak-e ólomhelyettesítőt?", a: "Általában nem — az ólom tovább bírja. Ahol jogszabály korlátozza, jóváhagyott helyettesítőt használunk." },
      { q: "Miért párásodik a tetőm?", a: "Majdnem mindig szellőzési hiba, nem szigetelési. Először diagnosztizálunk, csak utána ajánlunk." },
      { q: "Frissíthető a szigetelés bontás nélkül?", a: "Néha — szarufa-méret és rétegrend függvénye. A felmérés válaszol erre, nem a telefon." },
      { q: "Kéményt is csinálnak?", a: "Igen — kéményt újrafalazunk, újrabádogozunk és újraszigetelünk egyetlen munkafolyamatban." },
    ],
  },
];

export const PROJECTS = [
  { title: "Modern családi ház · Korcolt lemezfedés", photo: "/projects/proj-1.jpg" },
  { title: "Hegyi faház · Fémcserép fedés", photo: "/projects/proj-2.jpg" },
  { title: "Tetőtér beépítés · Korcolt lemez", photo: "/projects/proj-3.jpg" },
  { title: "Tetőfelújítás · Állókorcolt lemez", photo: "/projects/proj-4.jpg" },
  { title: "Modern villa · Korcolt fémtető", photo: "/projects/proj-5.jpg" },
  { title: "Rönkház · Tetőszerkezet és bádogozás", photo: "/projects/proj-6.jpg" },
  { title: "Rönkház · Cseréptetős fedés", photo: "/projects/proj-7.jpg" },
  { title: "Faház · Tetőépítés és szegélyezés", photo: "/projects/proj-8.jpg" },
];

export const REVIEWS = [
  {
    name: "Margit D.",
    rating: 5,
    excerpt:
      "Tibor brigádja újrafedte a polgári házunkat. A munka feltűnés nélkül zajlott, négy nappal a vállalt határidő előtt készen lettek, és minden este tiszta volt a telek. Az írásos garancia egy héttel később postán megérkezett.",
    date: "2024. október",
  },
  {
    name: "Jakab R.",
    rating: 5,
    excerpt:
      "Három árajánlatot kértünk. Sziráki volt az egyetlen, aki felmászott a tetőre, mielőtt árazott. A részletes ajánlata volt a legpontosabb, és a végszámla 30 ezer Ft-tal tért el tőle.",
    date: "2024. szeptember",
  },
  {
    name: "Pongor Tamás",
    rating: 5,
    excerpt:
      "Korcolt cink modern bővítésre, az építészünk specifikációja szerint. Tibor mintát hozott, elmagyarázta az attikabekötést, és pontosan azt csinálta, amit ígért.",
    date: "2024. augusztus",
  },
  {
    name: "Kovács R.",
    rating: 5,
    excerpt:
      "Védett parasztházon dolgoztunk. Az örökségvédelmi felügyelő egyetlen módosítás nélkül leigazolta. Ez nem véletlenül történik.",
    date: "2024. július",
  },
  {
    name: "Halász Ilona",
    rating: 5,
    excerpt:
      "Becsületes ár, nyomulás nélkül. Tibor megmondta, hogy a meglévő tetőnek még öt éve van, és most nem kell cserélni. Két év múlva másra őt hívtam vissza.",
    date: "2024. június",
  },
  {
    name: "Dudás Sára",
    rating: 5,
    excerpt:
      "Vihar utáni biztosítási ügy. Tibor intézte a kárszakértőt, a papírmunkát és a helyreállítást is. Lényegében semmit nem kellett csinálnunk.",
    date: "2024. május",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Nincs alvállalkozó.",
    body: "Saját, összeszokott csapattal dolgozunk. A tetőn nem dolgozik idegen, alkalmi napszámos.",
  },
  {
    n: "02",
    title: "Csak amit végig viszünk.",
    body: "Annyi munkát vállalunk, amennyit valóban végig tudunk vinni. Ha tele a naptár, azt őszintén megmondjuk.",
  },
  {
    n: "03",
    title: "A felmérés a tetőn történik.",
    body: "Telefon és fotó alapján nem árazunk. Felmegyünk a tetőre, és a helyszínen nézzük meg a tényleges állapotot.",
  },
  {
    n: "04",
    title: "Az ajánlat tételes.",
    body: "Sorról sorra látja, mit fizet. A végszámla nem okoz meglepetést — ezt írásban is vállaljuk.",
  },
  {
    n: "05",
    title: "A garanciát vállaljuk.",
    body: "Nem csak cégpecsét: a garancialevelet személyesen vállaljuk. Ha probléma van, minket hív, és mi jövünk.",
  },
];

export const CREDENTIALS = [
  "Tanúsítványok — egyeztetni kell",
  "Biztosítások — egyeztetni kell",
  "Garancia — egyeztetni kell",
  "Minősítések — egyeztetni kell",
];
